"use client";

import { IBlogsCategory } from "@/api/AppApi/services/blogs/interfaces/IBlogs";
import { numAsString } from "@/utils/functions/functions";
import { useBlogPushQuery } from "@/utils/functions/useBlogPushQuery";
import { useSearchParams } from "next/navigation";

interface props {
  filter: IBlogsCategory;
  fkey: string;
}

const Filter: React.FC<props> = ({ filter, fkey }) => {
  const { pushQueryToRouter } = useBlogPushQuery();
  const searchParams = useSearchParams();
  const currentValue = searchParams?.get(fkey);
  const isActive = currentValue === filter?.key;

  const handleClick = () => {
    pushQueryToRouter(
      [{ name: fkey, val: isActive ? "" : filter?.key }],
      true
    );
  };

  return (
    <div
      className={`blog-filter ${isActive ? "active" : ""}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleClick();
      }}
    >
      <p>
        {isActive && <span style={{ marginInlineEnd: 6 }}>✕</span>}
        {filter?.value}
      </p>
      <p className="arbaic-num">{`(${numAsString(filter?.blogs_count ?? 0)})`}</p>
    </div>
  );
};

export default Filter;
